import React from "react";

const Ribbon = ({ children }) => {
  return (
    <span className="px-3 py-2 font-bold text-xxs border border-[#EEA4BB] rounded-[3px] shadow-ribbon1 bg-detail-border-color">
      {children}
    </span>
  );
};

export default Ribbon;
